import { Injectable } from "@angular/core";
import { RequestCacheService } from '../_helpers/request-cache.service';
import { Observable, firstValueFrom, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import {
  GetUserByIdGQL,
  GetoccupieduserGQL,
  InsertUserCompanyGQL, GetUserCompanyGQL, User_Company_Roles_Enum,
  UpdateUserGQL, RegisterNewUserGQL,
  Users_Set_Input,
  DeleteUserGQL,
  RegisterUserData,
  UpdateSeeSettingsGQL,
  RegisterDipGQL,
  DipendentiData,
  UpdateUserStateGQL,
  User_Company_States_Enum,
  GetAllUsersGQL,
  GetRolesGQL,
  GetAllManagersGQL,
  User_States,
  GetUsersGQL,
  InsertLinkGQL,
  InsertLinkGQL1,
  GetLinksGQL,
  DeleteLinkGQL,
  GetDocumentsGQL,
  UploadFileGQL,
  CustomNotifGQL,
  UploadEvRicevutaGQL,
  DeleteDocumentGQL,
  GetAllLinksGQL,
  GetAllDocumentsGQL,
  GetUsersImpinatoGQL,
  IncreaseCreditGQL
} from "../../generated/graphql";

const GET_USER_WALLETS = gql`
  query getUserWallets($userId: uuid!) {
    wallets(
      where: { user_id: { _eq: $userId } }
      order_by: { updated_at: desc }
    ) {
      balance
      updated_at
      user_id
      ev_ricevuta {
        file_link
      }
    }
  }
`;

const GET_AUTHORIZE_CREDITS_BY_USER_IDS = gql`
  query getAuthorizeCreditsByUserIds($userIds: [uuid!]) {
    authorize(where: { user_id: { _in: $userIds } }) {
      user_id
      credit
      status
    }
  }
`;

const UPDATE_USER_SALES_MANAGER = gql`
  mutation updateUserSalesManager($userId: uuid!, $salesManagerId: uuid) {
    update_users_by_pk(
      pk_columns: {id: $userId}
      _set: {sales_manager_id: $salesManagerId}
    ) {
      id
      sales_manager_id
    }
  }
`;

const GET_USER_SALES_MANAGER = gql`
  query getUserSalesManager($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      sales_manager_id
    }
  }
`;

const GET_USER_COMPANY = gql`
  query getUserCompany($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      company_id
    }
  }
`;

const GET_USER_SALES_DIRECTOR = gql`
  query getUserSalesDirector($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      sales_director_id
    }
  }
`;

const GET_SALES_MANAGER_DIRECTOR_ASSIGNMENTS = gql`
  query getSalesManagerDirectorAssignments {
    users(where: {role: {_eq: sales_manager}}) {
      id
      sales_director_id
    }
  }
`;

const RESEND_ACTIVATION_LINK = gql`
  mutation resendActivationLink($email: String!) {
    resendActivationLink(email: $email) {
      success
      message
    }
  }
`;

const REGISTER_USER_WITH_LOCATION = gql`
  mutation registerUserWithLocation(
    $companyId: String,
    $email: String!,
    $fiscal_code: String,
    $name: String!,
    $note: String,
    $password: String!,
    $phone: String!,
    $role: String!,
    $surname: String!,
    $partita: String,
    $sales_manager_id: String,
    $sales_director_id: String,
    $address: String,
    $city: String,
    $cap: String,
    $province: String,
    $nationality: String,
    $zone_coperta: String,
    $crm_enabled: Boolean
  ) {
    registerUser(data: {
      companyId: $companyId,
      email: $email,
      fiscal_code: $fiscal_code,
      name: $name,
      note: $note,
      password: $password,
      phone: $phone,
      role: $role,
      surname: $surname,
      partita: $partita,
      sales_manager_id: $sales_manager_id,
      sales_director_id: $sales_director_id,
      address: $address,
      city: $city,
      cap: $cap,
      province: $province,
      nationality: $nationality,
      zone_coperta: $zone_coperta,
      crm_enabled: $crm_enabled
    }) {
      success
      data
    }
  }
`;

const UPDATE_USER_DETAIL_WITHOUT_SALES_MANAGER = gql`
  mutation updateUserDetailWithoutSalesManager(
    $address: String,
    $cap: String,
    $city: String,
    $nationality: String,
    $province: String,
    $company_id: String,
    $email: String!,
    $fiscal_code: String,
    $id: String!,
    $name: String!,
    $note: String,
    $phone: String!,
    $role: String!,
    $surname: String!,
    $state: String,
    $zone_coperta: String,
    $crm_enabled: Boolean
  ) {
    updateUserInfo(data: {
      address: $address,
      cap: $cap,
      city: $city,
      nationality: $nationality,
      province: $province,
      email: $email,
      fiscal_code: $fiscal_code,
      id: $id,
      name: $name,
      note: $note,
      phone: $phone,
      role: $role,
      surname: $surname,
      company_id: $company_id,
      state: $state,
      zone_coperta: $zone_coperta,
      crm_enabled: $crm_enabled
    }) {
      success
    }
  }
`;

const UPDATE_USER_DETAIL_WITH_SALES_MANAGER = gql`
  mutation updateUserDetailWithSalesManager(
    $address: String,
    $city: String,
    $cap: String,
    $province: String,
    $nationality: String,
    $company_id: String,
    $email: String!,
    $fiscal_code: String,
    $id: String!,
    $name: String!,
    $note: String,
    $phone: String!,
    $role: String!,
    $surname: String!,
    $sales_manager_id: String,
    $state: String,
    $zone_coperta: String
    $sales_director_id: String,
    $crm_enabled: Boolean
  ) {
    updateUserInfo(data: {
      address: $address,
      city: $city,
      cap: $cap,
      province: $province,
      nationality: $nationality,
      email: $email,
      fiscal_code: $fiscal_code,
      id: $id,
      name: $name,
      note: $note,
      phone: $phone,
      role: $role,
      surname: $surname,
      company_id: $company_id,
      sales_manager_id: $sales_manager_id,
      state: $state,
      zone_coperta: $zone_coperta
      sales_director_id: $sales_director_id,
      crm_enabled: $crm_enabled
    }) {
      success
    }
  }
`;

const UPDATE_USER_DETAIL_WITH_SALES_DIRECTOR = gql`
  mutation updateUserDetailWithSalesDirector(
    $address: String,
    $city: String,
    $cap: String,
    $province: String,
    $nationality: String,
    $company_id: String,
    $email: String!,
    $fiscal_code: String,
    $id: String!,
    $name: String!,
    $note: String,
    $phone: String!,
    $role: String!,
    $surname: String!,
    $sales_director_id: String,
    $state: String,
    $zone_coperta: String,
    $crm_enabled: Boolean
  ) {
    updateUserInfo(data: {
      address: $address,
      city: $city,
      cap: $cap,
      province: $province,
      nationality: $nationality,
      email: $email,
      fiscal_code: $fiscal_code,
      id: $id,
      name: $name,
      note: $note,
      phone: $phone,
      role: $role,
      surname: $surname,
      company_id: $company_id,
      sales_director_id: $sales_director_id,
      state: $state,
      zone_coperta: $zone_coperta,
      crm_enabled: $crm_enabled
    }) {
      success
    }
  }
`;

const GET_OWN_USER_INFO = gql`
  query getOwnUserInfo($id: String!) {
    getUserInfo(data: { id: $id }) {
      id name surname email phone fiscal_code
      address city cap province nationality zone_coperta
    }
  }
`;

// Only the fields the signer can edit about themself. The Action overwrites every field it receives,
// so the stored ones are sent back unchanged. state/role/crm_enabled/company and manager ids are never sent
// (state would switch the Action to a mode that rewrites role and permissions).
const UPDATE_OWN_CONTACT_INFO = gql`
  mutation updateOwnContactInfo(
    $id: String!,
    $email: String!,
    $zone_coperta: String,
    $name: String!,
    $surname: String!,
    $phone: String!,
    $fiscal_code: String,
    $address: String,
    $city: String,
    $cap: String,
    $province: String,
    $nationality: String
  ) {
    updateUserInfo(data: {
      id: $id,
      email: $email,
      zone_coperta: $zone_coperta,
      name: $name,
      surname: $surname,
      phone: $phone,
      fiscal_code: $fiscal_code,
      address: $address,
      city: $city,
      cap: $cap,
      province: $province,
      nationality: $nationality
    }) {
      success
    }
  }
`;

const GET_USER_CRM_ENABLED = gql`
  query getUserCrmEnabled($id: uuid!) {
    users(where: {id: {_eq: $id}}) {
      crm_enabled
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UsersService {
  notifier: any;
  constructor(
    private requestCache: RequestCacheService,
    private getUserByIdGQL: GetUserByIdGQL,
    private getoccupieduserGQL: GetoccupieduserGQL,
    private registerDipGQL: RegisterDipGQL,
    private insertUserCompanyGQL: InsertUserCompanyGQL,
    private getUserCompanyGQL: GetUserCompanyGQL,
    private registerUserGQL: RegisterNewUserGQL,
    private deleteUserGQL: DeleteUserGQL,
    private updateSeeSettingsGQL: UpdateSeeSettingsGQL,
    private updateUserStateGQL: UpdateUserStateGQL,
    private getAllUsersGQL: GetAllUsersGQL,
    private getRolesGQL: GetRolesGQL,
    private getAllManagersGQL: GetAllManagersGQL,
    private getUsersGQL: GetUsersGQL,
    private insertLinkGQL: InsertLinkGQL,
    private insertLinkGQL1: InsertLinkGQL1,
    private getLinksGQL: GetLinksGQL,
    private deleteLinkGQL: DeleteLinkGQL,
    private getDocumentsGQL: GetDocumentsGQL,
    private uploadFileGQL: UploadFileGQL,
    private customNotifGQL: CustomNotifGQL,
    private uploadEvRicevutaGQL: UploadEvRicevutaGQL,
    private deleteDocumentGQL: DeleteDocumentGQL,
    private getAllLinksGQL: GetAllLinksGQL,
    private getAllDocumentsGQL:GetAllDocumentsGQL,
    private getUsersImpinatoGQL:GetUsersImpinatoGQL,
    private increaseCreditGQL: IncreaseCreditGQL,
    private apollo: Apollo
  ) {}

  // getUserInfo Action, shared for 60s: pages resolve the same user ids many times (EV transactions, header).
  getUserById(userId: string): Observable<any> {
    return this.requestCache.get(`users:byId:${userId}`, () => this.getUserByIdGQL.fetch({ id: userId }).pipe(map((result) => {
      const user = result.data?.getUserInfo;
      if (!user) {
        const message = result.errors?.map(error => error.message).join('; ')
          || 'getUserInfo non ha restituito dati.';
        throw new Error(message);
      }
      return user;
    })), 60_000);
  };
  getoccupieduser(userId: string): Observable<any> {
    return this.getoccupieduserGQL.fetch({ id: userId }).pipe(map((result) => {
      const user = result.data?.getUserInfo;
      if (!user) {
        const message = result.errors?.map(error => error.message).join('; ')
          || 'getUserInfo non ha restituito dati.';
        throw new Error(message);
      }
      return user;
    }));
  }

  insertLink(body: any): Observable<any> {
    return this.insertLinkGQL.mutate({ link: body.link, title: body.title, user_id: body.user_id, role: body.role}).pipe(map((result) => {
  if (!result.data) {
    throw new Error('Unexpected: create-cron mutation returned no data');
  }
  return result.data.insert_links_one;}));
  };
  insertLinkWithoutRole(body: any): Observable<any> {
    return this.insertLinkGQL1.mutate({ link: body.link, title: body.title, user_id: body.user_id}).pipe(map((result) => {
  if (!result.data) {
    throw new Error('Unexpected: create-cron mutation returned no data');
  }
  return result.data.insert_links_one;}));
  };

  uploadFile(body: any): Observable<any> {

    return this.uploadFileGQL.mutate({ pdf: body.pdf, title: body.title, user_id: body.user_id, role: body.role }).pipe(map((result) => {
      if (!result.data) {
        throw new Error('Unexpected: create-cron mutation returned no data');
      }result.data.uploadPDFToBucket}));
  };

  customNotif(body: any): Observable<any> {

    return this.customNotifGQL.mutate({ subject: body.subject, message: body.message, user_id: body.user_id, role: body.role }).pipe(map((result) => {
      if (!result.data) {
        throw new Error('Unexpected: create-cron mutation returned no data');
      }return  result.data.sendCustomNotif}));
  };

  getAllUsers(id: string, role: string): Observable<any> {
    return this.getAllUsersGQL.fetch({ userId: id, userRole: role }).pipe(
      map((result) => result.data?.getAllUsers ?? []),
    );
  }

  getUsersImpianti(id: string): Observable<any> {
    return this.getUsersImpinatoGQL.fetch({impianto_id: id}).pipe(map((result) => result.data.impianti_users));
  }

  getLinks(id: string): Observable<any> {
    if (!id || id.trim() === '') {
    // Add detailed logging for debugging
    console.trace('getLinks called with invalid ID');
    return of([]); // Return empty observable instead of error
  }
    return this.getLinksGQL.fetch({ _eq: id }, { fetchPolicy: 'network-only' }).pipe(map((result) => result.data.links));
  }

  private formatApolloError(error: any): string {
    if (error?.graphQLErrors?.length) {
      return error.graphQLErrors.map((item: any) => item.message).join(' | ');
    }

    if (error?.networkError?.error?.errors?.length) {
      return error.networkError.error.errors.map((item: any) => item.message).join(' | ');
    }

    if (error?.networkError?.message) {
      return error.networkError.message;
    }

    if (error?.message) {
      return error.message;
    }

    return 'Unknown GraphQL error';
  }

  getAllLinks(): Observable<any> {
    return this.getAllLinksGQL.fetch({}, { fetchPolicy: 'network-only' }).pipe(
      map((result) => {
        if (!result?.data?.links) {
          console.error('getAllLinks GraphQL error', result);
          return [];
        }
        return result.data.links;
      }),
      catchError((error) => {
        const message = this.formatApolloError(error);
        console.error('getAllLinks failed:', error);
        this.notifier.error('getAllLinks', message);
        return throwError(() => error);
      })
    );
  }

  getDocs(id: string): Observable<any> {
  if (!id) {
    return throwError(() => new Error('Invalid ID provided for getDocs'));
  }
  return this.getDocumentsGQL.fetch({ _eq: id }).pipe(
    map(result => {
      if (!result?.data?.documents) {
        throw new Error('No documents data received');
      }
      return result.data.documents;
    })
  );
}

  getAllDocs(): Observable<any> {
    return this.getAllDocumentsGQL.fetch({}).pipe(map((result) => result.data.documents));
  }

  deletelink($id: String): Observable<any> {
    return this.deleteLinkGQL.mutate({ uuid: $id });
  }
  updateLink(uuid: string, title: string, link: string) {
  return this.apollo.mutate({
    mutation: gql`
      mutation UpdateLink($uuid: uuid!, $title: String!, $link: String!) {
        update_links_by_pk(
          pk_columns: { uuid: $uuid }
          _set: {
            title: $title
            link: $link
          }
        ) {
          uuid
          title
          link
        }
      }
    `,
    variables: {
      uuid,
      title,
      link
    }
  });
}

  updateLinkJpg(uuid: string, jpg: string) {
    return this.apollo.mutate({
      mutation: gql`
        mutation UpdateLinkJpg($uuid: uuid!, $jpg: String!) {
          update_links_by_pk(
            pk_columns: { uuid: $uuid }
            _set: {
              jpg: $jpg
            }
          ) {
            uuid
            jpg
          }
        }
      `,
      variables: {
        uuid,
        jpg
      }
    });
  }

  uploadJpgToBucket(jpg: string, uuid: string): Observable<any> {
    return this.apollo.mutate({
      mutation: gql`
        mutation UploadJPGToBucket($jpg: String!, $uuid: String!) {
          uploadJPGToBucket(input: { jpg: $jpg, uuid: $uuid }) {
            message
            success
          }
        }
      `,
      variables: {
        jpg,
        uuid
      }
    }).pipe(
      map((result: any) => {
        const graphQLError = result?.errors?.[0]?.message;
        if (graphQLError) {
          throw new Error(graphQLError);
        }

        if (!result?.data?.uploadJPGToBucket) {
          throw new Error('Unexpected: uploadJPGToBucket mutation returned no data');
        }

        if (result.data.uploadJPGToBucket.success === false) {
          throw new Error(
            typeof result.data.uploadJPGToBucket.message === 'string'
              ? result.data.uploadJPGToBucket.message
              : 'Caricamento JPG fallito'
          );
        }

        return result.data.uploadJPGToBucket;
      })
    );
  }

  deleteNotificationsByUrl(url: string): Observable<any> {
    return this.apollo.mutate({
      mutation: gql`
        mutation DeleteNotificationsByUrl($url: String!) {
          delete_notification(where: { url: { _eq: $url } }) {
            affected_rows
          }
        }
      `,
      variables: {
        url,
      },
    }).pipe(
      map((result: any) => {
        const graphQLError = result?.errors?.[0]?.message;
        if (graphQLError) {
          throw new Error(graphQLError);
        }

        return result?.data?.delete_notification?.affected_rows ?? 0;
      })
    );
  }

  deleteDoc($id: String): Observable<any> {
    return this.deleteDocumentGQL.mutate({ uuid: $id });
  }

  getAllManagers(): Observable<any> {
    return this.getAllManagersGQL.fetch({}).pipe(map((result) => result.data.users));
  }

  getUsers($role: string): Observable<any> {
    return this.getUsersGQL.fetch(
      {_eq: $role},
      {fetchPolicy: 'network-only'},
    ).pipe(map((result) => result.data.users));
  }

  getRoles(): Observable<any> {
    return this.getRolesGQL.fetch({}).pipe(map((result) => result.data.roles));
  }

  updateUserSalesManager(userId: string, salesManagerId: string | null): Observable<void> {
    return this.apollo.mutate<any>({
      mutation: UPDATE_USER_SALES_MANAGER,
      variables: { userId, salesManagerId },
    }).pipe(map(result => {
      if (result.errors?.length) {
        throw new Error(result.errors.map((error: any) => error.message).join('; '));
      }
      if (!result.data?.update_users_by_pk?.id) {
        throw new Error('Associazione Sales manager non autorizzata da Hasura.');
      }
      return void 0;
    }));
  }

  getUserSalesManagerId(userId: string): Observable<string | null> {
    if (!userId) return of(null);
    return this.apollo.query<any>({
      query: GET_USER_SALES_MANAGER,
      variables: { userId },
      fetchPolicy: 'network-only',
    }).pipe(map(result => result.data?.users_by_pk?.sales_manager_id || null));
  }

  getUserCompanyId(userId: string): Observable<string | null> {
    if (!userId) return of(null);
    return this.apollo.query<any>({
      query: GET_USER_COMPANY,
      variables: { userId },
      fetchPolicy: 'network-only',
    }).pipe(map(result => result.data?.users_by_pk?.company_id || null));
  }

  getUserSalesDirectorId(userId: string): Observable<string | null> {
    if (!userId) return of(null);
    return this.apollo.query<any>({
      query: GET_USER_SALES_DIRECTOR,
      variables: {userId},
      fetchPolicy: 'network-only',
    }).pipe(
      map(result => result.data?.users_by_pk?.sales_director_id || null),
      catchError(error => {
        console.warn('[UsersService][sales-director-id] Lookup failed', {
          userId,
          error,
        });
        return of(null);
      }),
    );
  }

  getSalesManagerDirectorAssignments(): Observable<Array<{
    managerId: string;
    directorId: string | null;
  }>> {
    return this.apollo.query<any>({
      query: GET_SALES_MANAGER_DIRECTOR_ASSIGNMENTS,
      fetchPolicy: 'network-only',
    }).pipe(
      map(result => (result.data?.users || []).map((user: any) => ({
        managerId: user.id,
        directorId: user.sales_director_id || null,
      }))),
      catchError(error => {
        console.warn('[UsersService][manager-director-assignments] Lookup failed', error);
        return of([]);
      }),
    );
  }

  resendActivationLink(email: string): Observable<{
    success: boolean;
    message: string;
  }> {
    return this.apollo.mutate<any>({
      mutation: RESEND_ACTIVATION_LINK,
      variables: {email: String(email || '').trim().toLowerCase()},
    }).pipe(
      map(result => {
        if (result.errors?.length) {
          throw new Error(result.errors.map((error: any) => error.message).join('; '));
        }
        const response = result.data?.resendActivationLink;
        if (!response) {
          throw new Error('Il server non ha restituito una risposta.');
        }
        return response;
      }),
    );
  }

  private shouldSendSalesManagerId(role: string): boolean {
    return String(role || '').trim() === 'vendite';
  }

  private shouldSendSalesDirectorId(role: string): boolean {
    return ['sales_manager', 'vendite'].includes(String(role || '').trim());
  }

  private serializeZoneCoperta(value: any): string {
    return typeof value === 'string' ? value : JSON.stringify(value ?? []);
  }

  registerUser($object: any): Observable<any> {
  const variables: any = {
      companyId: $object.company_id,
      email: $object.email,
      fiscal_code: $object.fiscal_code,
      name: $object.name,
      note: $object.note,
      password: $object.password,
      phone: $object.phone,
      role: $object.role,
      surname: $object.surname,
      partita: $object.partita,
      address: $object.address,
      city: $object.city,
      cap: $object.cap,
      province: $object.province,
      nationality: $object.nationality,
      zone_coperta: this.serializeZoneCoperta($object.zone_coperta),
      crm_enabled: $object.crm_enabled === true,
    };

    if (this.shouldSendSalesManagerId($object.role)) {
      variables.sales_manager_id = $object.sales_manager_id;
    }
    if (this.shouldSendSalesDirectorId($object.role)) {
      variables.sales_director_id = $object.sales_director_id;
    }

    console.log('[AttivaCRM][registerUser][request]', {
      sourceCrmEnabled: $object.crm_enabled,
      sentCrmEnabled: variables.crm_enabled,
    });

    console.log('[UserHierarchyDebug][registerUser][request]', {
      createdRole: $object.role,
      sourceSalesManagerId: $object.sales_manager_id ?? null,
      sourceSalesDirectorId: $object.sales_director_id ?? null,
      sentSalesManagerId: variables.sales_manager_id ?? null,
      sentSalesDirectorId: variables.sales_director_id ?? null,
      variables,
    });

    return this.apollo.mutate({
      mutation: REGISTER_USER_WITH_LOCATION,
      variables,
    }).pipe(map((result: any) => {
      console.log('[AttivaCRM][registerUser][response]', { data: result?.data, errors: result?.errors });
      console.log('[UserHierarchyDebug][registerUser][response]', {
        data: result?.data,
        errors: result?.errors,
      });
      return result;
    }));
  }

  getUserCrmEnabled(userId: string): Observable<boolean> {
    return this.apollo.query<any>({
      query: GET_USER_CRM_ENABLED,
      variables: { id: userId },
      fetchPolicy: 'network-only',
    }).pipe(map((result) => result.data?.users?.[0]?.crm_enabled === true));
  }

  deleteUser($id: String): Observable<any> {
    return this.deleteUserGQL.mutate({ id: $id });
  }


  registerDip($dipList: DipendentiData[]): Observable<any> {
    return this.registerDipGQL.mutate({ dipendentiList: $dipList });
  }

  /** The logged-in user's own profile from the getUserInfo Action, never cached. */
  async getOwnProfile(userId: string): Promise<{
    id?: string; name?: string; surname?: string; email?: string; phone?: string; fiscal_code?: string;
    address?: string; city?: string; cap?: string; province?: string; nationality?: string; zone_coperta?: string;
  }> {
    const result: any = await firstValueFrom(this.apollo.query({
      query: GET_OWN_USER_INFO,
      variables: { id: userId },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    }));
    const info = result?.data?.getUserInfo;
    if (!info) throw new Error(result?.errors?.[0]?.message || 'Impossibile caricare il tuo profilo.');
    return info;
  }

  /**
   * Changes only name, surname and phone of the logged-in user. Every other profile value is read with
   * getUserInfo and sent back unchanged, because the Action overwrites all the fields it receives.
   */
  async updateOwnContactInfo(
    userId: string,
    changes: { name: string; surname: string; phone: string },
  ): Promise<void> {
    const current = await this.getOwnProfile(userId);
    if (!current.email) throw new Error('Impossibile caricare il tuo profilo. Contatta l’assistenza.');

    const result: any = await firstValueFrom(this.apollo.mutate({
      mutation: UPDATE_OWN_CONTACT_INFO,
      variables: {
        id: userId,
        email: current.email,
        zone_coperta: this.serializeZoneCoperta(current.zone_coperta),
        name: changes.name,
        surname: changes.surname,
        phone: changes.phone,
        fiscal_code: current.fiscal_code ?? null,
        address: current.address ?? null,
        city: current.city ?? null,
        cap: current.cap ?? null,
        province: current.province ?? null,
        nationality: current.nationality ?? null,
      },
      errorPolicy: 'all',
    }));
    if (result?.errors?.length) throw new Error(result.errors[0].message || 'Salvataggio dei dati non riuscito.');
    if (!result?.data?.updateUserInfo?.success) throw new Error('Salvataggio dei dati non riuscito.');
  }

  updateUser($userData: any): Observable<any> {
    const shouldSendSalesManagerId = this.shouldSendSalesManagerId($userData.role);
    const shouldSendSalesDirectorId = this.shouldSendSalesDirectorId($userData.role);
    const variables: any = {
      id: $userData.id,
      email: $userData.email,
      fiscal_code: $userData.fiscal_code,
      name: $userData.name,
      phone: $userData.phone,
      surname: $userData.surname,
      role: $userData.role,
      company_id: $userData.company_id,
      note: $userData.note,
      state: $userData.state,
      address: $userData.address ?? null,
      city: $userData.city ?? null,
      cap: $userData.cap ?? null,
      province: $userData.province ?? null,
      nationality: $userData.nationality ?? null,
      zone_coperta: this.serializeZoneCoperta($userData.zone_coperta),
    };

    if (shouldSendSalesManagerId) {
      variables.sales_manager_id = $userData.sales_manager_id;
    }
    if (shouldSendSalesDirectorId) {
      variables.sales_director_id = $userData.sales_director_id;
    }
    // Only sent when the dialog loaded the stored value: otherwise null leaves users.crm_enabled unchanged.
    if (typeof $userData.crm_enabled === 'boolean') {
      variables.crm_enabled = $userData.crm_enabled;
    }

    console.log('[AttivaCRM][updateUser][request]', {
      sourceCrmEnabled: $userData.crm_enabled,
      sentCrmEnabled: 'crm_enabled' in variables ? variables.crm_enabled : '(not sent: value never loaded)',
    });

    console.log('[UserUpdate][user-update-start]', {
      updateUserInfoVariables: variables,
      registryPayload: {
        registry_id: $userData.registry_id,
        address: $userData.address,
        city: $userData.city,
        cap: $userData.cap,
        province: $userData.province,
        nationality: $userData.nationality,
      },
      shouldSendSalesManagerId,
      shouldSendSalesDirectorId,
    });

    return this.apollo.mutate({
      mutation: shouldSendSalesManagerId
        ? UPDATE_USER_DETAIL_WITH_SALES_MANAGER
        : shouldSendSalesDirectorId
          ? UPDATE_USER_DETAIL_WITH_SALES_DIRECTOR
          : UPDATE_USER_DETAIL_WITHOUT_SALES_MANAGER,
      variables,
    }).pipe(
      map((userUpdateResult: any) => {
        console.log('[UserUpdate][user-update-result]', userUpdateResult);
        console.log('[AttivaCRM][updateUser][response]', { data: userUpdateResult?.data, errors: userUpdateResult?.errors });

        if (userUpdateResult?.errors?.length) {
          console.error('[UserUpdate][user-update-errors]', userUpdateResult.errors);
        }

        return userUpdateResult;
      })
    );
  }

  increaseUserCredit($userId: string, $cretorId: string, $amount: string): Observable<any> {
    return this.increaseCreditGQL.mutate({ userId: $userId, creatorId: $cretorId, balance: $amount.toString() });
  }

  getUserWalletHistory(userId: string): Observable<Array<{ balance: number; updated_at: string; ev_ricevuta: string }>> {
    if (!userId) {
      return throwError(() => new Error('Invalid user id'));
    }

    return this.apollo.watchQuery<{
      wallets: Array<{ balance: number; updated_at: string; ev_ricevuta: string }>;
    }>({
      query: GET_USER_WALLETS,
      variables: { userId },
      fetchPolicy: 'network-only',
    })
    .valueChanges.pipe(
      map(result => result?.data?.wallets ?? [])
    );
  }

  getAuthorizeCreditsByUserIds(userIds: string[]): Observable<Array<{ user_id: string; credit: number; status?: string }>> {
    if (!userIds || userIds.length === 0) {
      return of([]);
    }

    return this.apollo.query<{ authorize: Array<{ user_id: string; credit: number }>}>({
      query: GET_AUTHORIZE_CREDITS_BY_USER_IDS,
      variables: { userIds },
      fetchPolicy: 'network-only',
    })
    .pipe(map(result => result?.data?.authorize ?? []));
  }

  uploadEVricevuta(record: { wallet_id: string; impianti_id?: string | null; file_link: string; ricevuta_number: string }): Observable<any> {
    const payload = {
      wallet_id: record.wallet_id,
      pdf: record.file_link,
      rivecuta_number: record.ricevuta_number,
    };

    return this.uploadEvRicevutaGQL.mutate(payload);
  }

  updateSeeSetting($id: String, $set: boolean): Observable<any> {
    return this.updateSeeSettingsGQL.mutate({ _eq: $id, see_settings: $set});
  }

  updateUserState($id: String, $set: any): Observable<any> {
    return this.updateUserStateGQL.mutate({ id: $id, state : $set});
  }
}
